module.exports = __webpack_public_path__ + "img/Wall-Concrete-BPR-material-3D-texture-High-Resolution-Free-Download-4K-preview-full.ea156cc4.jpg";